import axios from 'axios'
import { multitenantApiBasePath } from './fetch'

export const getControlPanelData = (accessToken, tenantId, filterQuery) => {
  const config = {
    headers: { Authorization: `Bearer ${accessToken}`, tenantId },
  }

  return axios.get(
    `${multitenantApiBasePath}/ProductPanel?${filterQuery}`,
    config
  )
}

export const getExportRequest = (accessToken, tenantId, filterQuery) => {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      responseType: 'blob',
      tenantId,
    },
  }

  return axios.get(
    `${multitenantApiBasePath}/ProductPanel/export?${filterQuery}`,
    config
  )
}

export const getSitesControlPanel = (accessToken, tenantId, siteName) => {
  const config = {
    headers: { Authorization: `Bearer ${accessToken}`, tenantId },
  }

  return axios.get(
    `${multitenantApiBasePath}/ProductPanel/sites?request=${siteName}`,
    config
  )
}

export const getAssetsControlPanel = (accessToken, tenantId, assetName) => {
  const config = {
    headers: { Authorization: `Bearer ${accessToken}`, tenantId },
  }

  return axios.get(
    `${multitenantApiBasePath}/ProductPanel/assets?request=${assetName}`,
    config
  )
}

export const getAssetsBySitesControlPanel = (
  accessToken,
  tenantId,
  sitesIdsQuery
) => {
  const config = {
    headers: { Authorization: `Bearer ${accessToken}`, tenantId },
  }

  return axios.get(
    `${multitenantApiBasePath}/ProductPanel/assets/sites?${sitesIdsQuery}`,
    config
  )
}

export const getSitesByAssetsControlPanel = (
  accessToken,
  tenantId,
  assetsIdsQuery
) => {
  const config = {
    headers: { Authorization: `Bearer ${accessToken}`, tenantId },
  }

  return axios.get(
    `${multitenantApiBasePath}/ProductPanel/sites/assets?${assetsIdsQuery}`,
    config
  )
}
